import { Button, Card } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { Page } from "../../../../../-components/Page"
import { ScrollContainer } from "../../../../../-components/scroll-container"
import { AddCalendarProfile } from "../../../../../@client/Theasoft_ApiServer_WebCalendar"
import { WebCalendarProfileDto } from "../../../../../@client/Theasoft_Shared_Contracts_WebCalendar"
import { useSuspenseQueryGet } from "../../../../../typed-client/hooks/use-suspense-query-get"
import { useBreakpoints } from "../../../../../utils/use-breakpoints"
import { CalendarStack } from "../-calendar-list"
import { CreateCalendarModal } from "../-create-calendar-modal"
import { EditCalendarProfileModal } from "../-edit-calendar-modal"
import { pathProxy } from "../../../../../utils/forms-proxy"

const addCalendarProfilePathProxy = pathProxy<AddCalendarProfile>()

export function CalendarSubscriptionsPage() {
  const { t } = useTranslation("app_server")
  const [opened, setOpened] = React.useState(false)

  const [selectedProfile, setSelectedProfile] =
    React.useState<WebCalendarProfileDto | null>(null)

  const { data: canAdd } = useSuspenseQueryGet(
    "/api/web-calendar/can-add-personal-web-calendar-profile",
    null
  )

  const { xs } = useBreakpoints()

  return (
    <Page
      infoDescription={t("Calendar_Subscriptions_Description")}
      buttonGroupProps={
        canAdd && !xs
          ? {
              children: (
                <Button size="xs" onClick={() => setOpened(true)}>
                  {t("Calendar_Subscriptions_CreateButton")}
                </Button>
              ),
            }
          : undefined
      }
      dottedMenuProps={{
        items: [
          canAdd && xs
            ? {
                children: t("Calendar_Subscriptions_CreateButton"),
                onClick: () => setOpened(true),
              }
            : null,
        ],
      }}
    >
      {canAdd && (
        <>
          <CreateCalendarModal
            onClose={() => {
              setOpened(false)
            }}
            opened={opened}
            addCalendarProfilePathProxy={addCalendarProfilePathProxy}
          />
          <EditCalendarProfileModal
            profile={selectedProfile}
            onClose={() => {
              setSelectedProfile(null)
            }}
            addCalendarProfilePathProxy={addCalendarProfilePathProxy}
          />
        </>
      )}

      <Card mt="md">
        <ScrollContainer>
          <CalendarStack onEditProfileClick={setSelectedProfile} />
        </ScrollContainer>
      </Card>
    </Page>
  )
}
